export default __webpack_public_path__ + "static/media/blog.ebc003ab.svg";